import { useKorintModuleConfig } from 'korint-sdk/react';
import { PolicyTable } from '../../components/module-elements/PolicyTable/PolicyTable';

export function OngoingNewBusinessModule() {
  const ongoingNewBusiness = useKorintModuleConfig('ongoingNewBusiness');

  return (
    <PolicyTable
      filtersConfig={ongoingNewBusiness.filtersConfig}
      baseFilters={ongoingNewBusiness.baseFilters}
      expandBrokerageFirm={ongoingNewBusiness.expandBrokerageFirm}
      expandCustomers={ongoingNewBusiness.expandCustomers}
      expandAssets={ongoingNewBusiness.expandAssets}
      columns={ongoingNewBusiness.columns}
      initialFilters={ongoingNewBusiness.initialFilters}
      selectable
    />
  );
}
